import { memo } from 'react';
import { useTheme } from '@mui/material';
import EmailIllustrationLight from './email.svg?react';
import EmailIllustrationDark from './email_dark.svg?react';

export const EmailIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <EmailIllustrationDark aria-hidden="true" {...props} />;
    return <EmailIllustrationLight aria-hidden="true" {...props} />;
  },
);
